// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestionCard-cls1_pbS","cls2":"SuggestionCard-cls2_Fa9 SuggestionCard-cls1_pbS"};